var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dsr-published-app-container"},[_c('TransitionFadeInOut',[(_vm.loading)?_c('UniversalLoader',{attrs:{"message":"Loading session"}}):_c('PublishedView')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }